import React from 'react'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import {Form, Field} from 'simple-react-form'
import MultipleFiles from 'App/components/fields/MultipleFiles'
import fileUpload from 'App/helpers/fields/fileUpload'
import Button from 'orionsoft-parts/lib/components/Button'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import styles from './styles.css'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'

import emailValidation from 'App/helpers/validations/emailValidation'
import MdInfoOutline from 'react-icons/lib/md/info-outline'
import FileBinary from 'react-icons/lib/go/file-binary'

@withMutation(gql`
  mutation createMasiveFea(
    $files: [FileInput]
    $name: String
    $description: String
    $signerName: String
    $signerEmail: String
  ) {
    createMasiveFea(
      files: $files
      name: $name
      description: $description
      signerName: $signerName
      signerEmail: $signerEmail
    )
  }
`)

@withMessage
export default class MassiveFea extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      failed: [],
      firmasAUsar: 0
    }
  }
  static propTypes = {
    showMessage: PropTypes.func,
    organization: PropTypes.object,
    createMasiveFea: PropTypes.func
  }

  @autobind
  async load() {
    console.log('Subiendo archivos...')
    this.setState({loading: true, errorMessages: null})
    if (!this.state.files) {
      this.props.showMessage('Necesitas cargar los archivos')
      this.setState({loading: false})
      return
    }

    console.log('Voy a iterar por los archivos...', this.state.files)
    console.log('state ', this.state)
    let fileForServices = []
    this.state.files.forEach(file => {
      fileForServices.push(file.file)
    })
    console.log('fileForServices ', fileForServices)

    try {
      await this.props.createMasiveFea(
        {
          files: fileForServices,
          name: this.state.txName,
          description: this.state.txDesc,
          signerName: this.state.signer,
          signerEmail: this.state.signerEmail
        },
        {
          refetchQueries: [
            'myFeaDocumentsToSign',
            'documentCount',
            'organizationDocCount',
            'packsSignaturesCount',
            'planSignaturesCount'
          ]
        }
      )

      this.props.showMessage('Proceso finalizado con éxito')

    } catch (error) {
      console.log('Error:', error)
    }
    this.setState({loading: false, data: null, files: null})

    setTimeout(() => {
      this.props.router.push('/documents')
    }, 5000
    )

  }

  renderFirmasAGastar() {
    if (this.state.files) {
      return (
        <Tooltip content="">
          <div className="label">Se usarán {this.state.files.length} firmas avanzadas</div>
        </Tooltip>
      )
    }
  }

  render() {
    return (
      <div className="section">
        <div className="header">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8">
              <div className="row">
                <div className="col-xs-2 col-sm-">
                  <div className={styles.Icon}>
                    <FileBinary size={20} />
                  </div>
                </div>
                <div className="col-xs-10 col-sm-">
                  <div className={styles.Title2}>
                    <h3>Creacion FEA Masiva<Tooltip
                      content={'La autenticación será realizada mediante una entidad acreditada de firma electrónica avanzada'}
                    >
                      <MdInfoOutline size={20} className="info-tooltip"/>
                    </Tooltip></h3>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="content">
          <div>
            <Form state={this.state} onChange={changes => this.setState(changes)}>
              <Tooltip content="Documents to send">
                <div className="label">Documentos</div>
              </Tooltip>
              <Field fieldName="files" {...fileUpload} type={MultipleFiles} />
              <br />

              <Tooltip content="Se usará como prefijo de sus documentos">
                <div className="label">Nombre Operación</div>
              </Tooltip>
              <Field fieldName="txName" placeholder="Nombre Operación" type={Text}/>

              <Tooltip content="Descripción de operación">
                <div className="label">Descripción</div>
              </Tooltip>
              <Field fieldName="txDesc" placeholder="Descripción (opcional)" type={Text}/>

              <Tooltip content="Nombre de firmante">
                <div className="label">Nombre Firmante</div>
              </Tooltip>
              <Field fieldName="signer" placeholder="Nombre De Firmante" type={Text}/>

              <Tooltip content="email que realizara firma electrónica avanzada">
                <div className="label">Email Firmante</div>
              </Tooltip>
              <Field fieldName="signerEmail" placeholder="email@noip.cl" type={Text}/>

              <br />

              {this.renderFirmasAGastar()}
              <br />
              <div className="row">
                <div className="col-xs-12 center-xs col-sm-6 end-sm">
                  <div className={styles.view}>
                    <Button
                      primary
                      onClick={this.load}
                      loading={this.state.loading}
                      disabled={  !this.state.files || !this.state.txName || !this.state.signer || !this.state.signerEmail || !emailValidation(this.state.signerEmail) }>
                      Crear Firma Electrónica Avanzada Masiva
                    </Button>
                  </div>
                </div>
              </div>
            </Form>

          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/MassiveFEA/index.js